import type { FormErrorsDE } from "../de/de.formErrors";

export const FormErrorsEN: typeof FormErrorsDE = {
  invalidEmail: "The email address is invalid. (example@mail.com)",
  invalidUrl: "The URL is invalid. (https://example.com)",
};
